<div>
  <p class="authentication__right__card_title">
    {{ 'LOGIN.RECOVER_PASSWORD.TITLE' | translate }}
  </p>

  <p class="authentication__right__card_description">
    {{ 'LOGIN.RECOVER_PASSWORD.DESCRIPTION' | translate }}
  </p>

  <div
    class="authentication__right__card__field mt-27"
    fxLayout="column"
    fxLayoutAlign="center stretch"
    fxLayoutGap="8px"
  >
    <label class="authentication__right__card__field-label">
      {{ 'LOGIN.AUTH.EMAIL.INPUT' | translate }}
    </label>
    <div class="authentication__right__card__field__input-box">
      <input
        class="authentication__right__card__field__input-box_input"
        type="email"
        name="email"
        (keyup)="$event.key === 'Enter' && emailControl.valid && recoverAccount()"
        autocomplete="email"
        [formControl]="emailControl"
        [placeholder]="'LOGIN.AUTH.PLACEHOLDER' | translate"
      />

      <div *ngIf="emailControl.touched && emailControl.invalid">
        <small class="authentication__right__card__field-error" *ngIf="emailControl.hasError('required')">
          {{ 'LOGIN.AUTH.ERRORS.REQUIRED_EMAIL' | translate }}
        </small>
        <small class="authentication__right__card__field-error" *ngIf="emailControl.hasError('email')">
          {{ 'LOGIN.AUTH.ERRORS.INVALID_EMAIL' | translate }}
        </small>

        <small
          class="authentication__right__card__field-error"
          *ngIf="emailControl.hasError('loginIntegrationEnabled')"
        >
          {{ 'LOGIN.RECOVER_PASSWORD.ERRORS.LOGIN_INTEGRATION_ENABLED' | translate }}
        </small>

        <small class="authentication__right__card__field-error" *ngIf="emailControl.hasError('userNotFound')">
          {{ 'LOGIN.RECOVER_PASSWORD.ERRORS.USER_NOT_FOUND' | translate }}
        </small>

        <small class="authentication__right__card__field-error" *ngIf="emailControl.hasError('userDisabled')">
          {{ 'LOGIN.RECOVER_PASSWORD.ERRORS.USER_DISABLED' | translate }}
        </small>

        <small class="authentication__right__card__field-error" *ngIf="emailControl.hasError('attemptsExceed')">
          {{ 'LOGIN.RECOVER_PASSWORD.ERRORS.ATTEMPTS_EXCEEDED' | translate }}
        </small>

        <small class="authentication__right__card__field-error" *ngIf="emailControl.hasError('unknown')">
          {{ 'LOGIN.RECOVER_PASSWORD.ERRORS.FAILED' | translate }}
        </small>
      </div>
    </div>
  </div>

  <button
    class="authentication__right__card_next mt-22"
    mat-raised-button
    [disabled]="emailControl.invalid || isLoading"
    (click)="recoverAccount()"
  >
    {{ 'LOGIN.RECOVER_PASSWORD.SEND_MAIL' | translate }}
  </button>

  <p class="authentication__right__card_description mt-27">
    {{ 'LOGIN.RECOVER_PASSWORD.NOTES' | translate }}
  </p>
</div>
